export default __webpack_public_path__ + "static/media/ie-edge_chrome_safari.05eb7cac.svg";